<script>

import { useDonationsPublicStore } from '@/stores/donationPublic.js'
import TwTransitionContainer from '@/components/generic/tw-transition-container.vue'
import { useFundraiserPagePublicStore } from '@/stores/fundraiserPagePublic.js'
import TwButton from '@/components/generic/tw-button.vue'
import fundraiserPagePublicFetchMixin from '@/mixins/fundraiserPagePublicFetchMixin.js'
import TwCardWithBackdrop from '@/components/generic/tw-card-with-backdrop.vue'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import TwModal from '@/components/generic/modal/tw-modal.vue'
import FundraiserPageSocialsShare from '@/components/fundraiser-pages/fundraiser-page-socials-share.vue'
import DonationPublicDetails from '@/components/donations/donation-public-details.vue'
export default {
  name: 'FundraiserPageDonationReturnPublicPage',
  components: {
    DonationPublicDetails,
    FundraiserPageSocialsShare, TwModal,
    TwLoadingSpinner,
    TwButton,
    TwCardWithBackdrop,
    TwTransitionContainer,
  },
  mixins:[fundraiserPagePublicFetchMixin],
  props: {
    donationId: {
      type: Number,
      required: true
    },
  },
  computed: {
    donation() {
      return useDonationsPublicStore().getItemById(this.donationId)
    }
  },
  mounted() {
    useFundraiserPagePublicStore().fetchItemById(this.fundraiserPageId)
    useDonationsPublicStore().fetchItemById(this.donationId)
    useDonationsPublicStore().processCheckout(this.donationId)
  },
  methods: {
    closed() {
      this.$router.push({ name: 'FundraiserPagePublicPage', params: { fundraiserPageId: this.fundraiserPage.id, slug: this.fundraiserPage.slug } })
    }
  }
}
</script>

<template>
  <tw-transition-container>
    <tw-card-with-backdrop v-if="fundraiserPage && donation" :backdrop-url="fundraiserPage.cover_image_url" show-close-button @close="closed">
      <div class="flex flex-row justify-center my-6">
        <icon icon="check-circle" class="h-12 text-green-500" />
      </div>
      <div class="text-center mb-8 flex flex-col gap-2">
        <h2>
          Thank you!
        </h2>
        <h4>Your donation was successfully processed. </h4>
        <p>You can help advance your impact by helping spread the word about this campaign. </p>
      </div>
      <tw-button class="mt-4" variant="secondary" block size="lg" @click="$refs.shareModal.open()">
        Help Spread The Word
      </tw-button>
      <!-- <h4 class="text-center mt-10 mb-5">
        Gift Summary
      </h4> -->
      <donation-public-details :donation="donation" />
      <div class="flex justify-center mt-8 mb-4">
        <img :src="fundraiserPage.logo_url" class="max-h-28 max-w-48">
      </div>
      <div class="text-center text-xs">
        Your donation is safe and secure. All proceeds of your donation will go directly to <span class="font-semibold">{{ fundraiserPage.cached.beneficiary_name }}</span>
      </div>
      <tw-modal ref="shareModal" ok-only ok-text="Close" variant="secondary" title="Share this fundraiser" @ok="$refs.shareModal.close()">
        <fundraiser-page-socials-share :fundraiser-page="fundraiserPage" />
      </tw-modal>
    </tw-card-with-backdrop>
    <tw-loading-spinner v-else />
  </tw-transition-container>
</template>

<style scoped>

</style>
